var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 64,
    viewBox: "0 0 77 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76.0908,
    height: 63.7105,
    rx: 9.28524,
    fill: "#0E6AC7",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4323 26.8146C43.8559 24.5376 29.5615 36.8457 30.522 53.1714M24.2526 21.8241C24.2526 23.1544 24.781 24.4301 25.7216 25.3707C26.6622 26.3113 27.9379 26.8397 29.2681 26.8397C30.5983 26.8397 31.8741 26.3113 32.8147 25.3707C33.7553 24.4301 34.2837 23.1544 34.2837 21.8241C34.2837 20.4939 33.7553 19.2182 32.8147 18.2776C31.8741 17.337 30.5983 16.8086 29.2681 16.8086C27.9379 16.8086 26.6622 17.337 25.7216 18.2776C24.781 19.2182 24.2526 20.4939 24.2526 21.8241Z",
    stroke: "#062C80",
    strokeWidth: 3.76167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4754 34.5285C22.447 33.563 28.7039 36.9309 32.0869 42.3026",
    stroke: "#062C80",
    strokeWidth: 3.76167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4754 25.3349C15.4754 19.7175 15.4754 16.9088 16.5688 14.7621C17.5305 12.8748 19.065 11.3402 20.9524 10.3785C23.099 9.28516 25.9078 9.28516 31.5252 9.28516H44.5656C50.183 9.28516 52.9918 9.28516 55.1384 10.3785C57.0258 11.3402 58.5603 12.8748 59.522 14.7621C60.6154 16.9088 60.6154 19.7175 60.6154 25.3349V38.3754C60.6154 43.9928 60.6154 46.8015 59.522 48.9482C58.5603 50.8356 57.0258 52.3701 55.1384 53.3318C52.9918 54.4252 50.183 54.4252 44.5656 54.4252H31.5252C25.9078 54.4252 23.099 54.4252 20.9524 53.3318C19.065 52.3701 17.5305 50.8356 16.5688 48.9482C15.4754 46.8015 15.4754 43.9928 15.4754 38.3754V25.3349Z",
    stroke: "#062C80",
    strokeWidth: 3.76167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.02b0c9b4924d0cbdcf077add1d86daee.svg";
export { ForwardRef as ReactComponent };